import {
	ALLOWED_CNH_CATEGORIES,
	type CnhCategory,
} from "../constants/list-drivers.constants";

export const normalizeCategoryCnh = (value?: string | null): CnhCategory[] => {
	if (!value) {
		return [];
	}

	return value
		.replace(/([ABCDE])(?!,)/g, "$1,")
		.split(",")
		.map((v) => v.trim())
		.filter((v): v is CnhCategory =>
			ALLOWED_CNH_CATEGORIES.includes(v as CnhCategory)
		);
};
